import store from '@/store';

const defaultScale = store.getState().configs.data?.defaultScale ?? 2;

function formatNumber({
  value,
  locale,
  maximumFractionDigits = defaultScale,
  minimumFractionDigits = defaultScale,
}: {
  value: number | string | undefined | null;
  locale: string;
  maximumFractionDigits?: number;
  minimumFractionDigits?: number;
}) {
  if (!value && value !== 0) {
    return value;
  }

  if (typeof value === 'number') {
    value = value.toString();
  }

  if (value.includes('.')) {
    value = value.slice(0, value.indexOf('.') + maximumFractionDigits + 1);
  }

  return new Intl.NumberFormat(locale === 'fr' ? 'fr' : 'en', {
    maximumFractionDigits,
    minimumFractionDigits,
    // @ts-expect-error
  }).format(value);
}

export default formatNumber;
